import * as React from 'react';
import { VideoPlayer } from '../video-player';

import * as styles from './reliably.css';

export class Reliably extends React.Component<{}> {
  public render() {
    return (
      <div>
        <VideoPlayer videoURL="gAKcwqqo_Qk" />
        <p className={styles['title']}>Мы строим для вас дома 25 лет</p>
        <p className={styles['description']}>
          25&nbsp;млн квадратных метров, построенных ПИК с&nbsp;1994&nbsp;года, стали домом для 500&nbsp;000&nbsp;семей.
          Это просто числа, за&nbsp;которыми скрывается главное. ПИК&nbsp;&mdash; это новое качество жизни
          и&nbsp;надёжность. Для всех.
        </p>
      </div>
    );
  }
}
